import React, { useEffect, useState } from 'react';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import Head from "../components/Head";
import VehicleCard from "../components/VehicleCard";
import fleet from "../data/fleet";

function Fleet() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Animation effect for form elements
  useEffect(() => {
    const animateFormElements = () => {
      const elements = document.querySelectorAll('.animate-in');

      elements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('show');
        }, 100 * index);
      });
    };

    // Run animation after a short delay
    setTimeout(animateFormElements, 200);
  }, []);

  useEffect(() => {
    try {
      setTimeout(() => {
        setVehicles(fleet);
        setLoading(false);
      }, 500);
    } catch (err) {
      console.error('Error fetching vehicle data:', err);
      setError('Failed to load vehicle data. Please try again later.');
      setLoading(false);
    }
  }, []);

  // Function to handle image loading error
  const handleImageError = (e) => {
    e.target.src = '/images/placeholder-vehicle.jpg'; // Fallback image
    e.target.alt = 'Vehicle image not available';
  };

  // Function to create star ratings
  const renderStars = (count = 5) => {
    return Array(count).fill().map((_, i) => (
      <span key={i} className="text-primary">
        <i className="fas fa-star"></i>
      </span>
    ));
  };

  // State to manage the image source for each car
  const [imageSrc, setImageSrc] = useState({
    "escalade-img": "images/escalade_SUV.jpg",
    "suburban-img": "images/blk_chevy_suburban.jpg",
    "hyundai-img": "images/hyundai_SUV.jpg",
    "hummer-img": "images/hummer_h2.jpg",
    "mercedes-img": "images/mercedes_benz.jpg",
    "jeep-img": "images/jeep_wrangler.jpg",
    "porsche-img": "images/porsche_cayenne.jpg",
    "lexus-img": "images/lexus_gx550.jpg",
  });

  // Mouse over handler
  const handleMouseOver = (e) => {
    const idValue = e.target.id;
    switch (idValue) {
      case "escalade-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/escalade-2.jpg"}));
        break;
      case "suburban-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/blk_suburban_back.jpg"}));
        break;
      case "hyundai-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hyundai-img-2.jpg"}));
        break;
      case "hummer-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hummer-img-2.jpg"}));
        break;
      case "mercedes-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hyundai_SUV.jpg"}));
        break;
      case "jeep-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hyundai_SUV.jpg"}));
        break;
      case "porsche-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hyundai_SUV.jpg"}));
        break;
      case "lexus-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hyundai_SUV.jpg"}));
        break;
      default:
        break;
    }
  };

  // Mouse out handler
  const handleMouseOut = (e) => {
    const idValue = e.target.id;
    switch (idValue) {
      case "escalade-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/escalade_SUV.jpg"}));
        break;
      case "suburban-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/blk_chevy_suburban.jpg"}));
        break;
      case "hyundai-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hyundai_SUV.jpg"}));
        break;
      case "hummer-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/hummer_h2.jpg"}));
        break;
      case "mercedes-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/mercedes_benz.jpg"}));
        break;
      case "jeep-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/jeep_wrangler.jpg"}));
        break;
      case "porsche-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/porsche_cayenne.jpg"}));
        break;
      case "lexus-img":
        setImageSrc((prev) => ({...prev, [idValue]: "images/lexus_gx550.jpg"}));
        break;
      default:
        break;
    }
  };

  return (
      <>
        <Head pageTitle="AMR - Fleet"/>
        <NavigationBar/>

        <style jsx="true">{`
          /* Animation styles */
          .animate-in {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.5s ease, transform 0.5s ease;
          }

          .animate-in.show {
            opacity: 1;
            transform: translateY(0);
          }
        `}</style>

        <section id="special" className="py-5 fleet first-section">
          <div className="container">
            <div className="title text-center py-5 animate-in">
              <h2 className="position-relative d-inline-block">Fleet</h2>
            </div>

            {loading ? (
                <div className="text-center py-5 animate-in">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading our luxury fleet...</p>
                </div>
            ) : error ? (
                <div className="alert alert-danger text-center" role="alert">
                  {error}
                </div>
            ) : (
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4">
                  {vehicles.map((fleet, i) => (
                      <VehicleCard
                          vehicleName={fleet.vehicle_name}
                          key={i}
                          vehicleAlt={fleet.image_alt}
                          vehicleMakeAndModel={fleet.make_and_model}
                          vehicleImageSrc={imageSrc[`${fleet.vehicle_name}-img`]}
                          onError={handleImageError}
                          onMouseOver={handleMouseOver}
                          onMouseOut={handleMouseOut}
                          renderStars={renderStars()}
                      />
                  ))}
                </div>
            )}
          </div>
        </section>
        <Footer/>
      </>
  );
}

export default Fleet;